import { render, staticRenderFns } from "./ProfileSectionView.vue?vue&type=template&id=3bc01afe&"
import script from "./ProfileSectionView.vue?vue&type=script&lang=js&"
export * from "./ProfileSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports